import React from 'react';

const SolForum = () => {
  return <h1>SolForum Page</h1>;
};

export default SolForum;
